import axios from 'axios';
import { toProductModel } from '../../mappers/posts/toPostModel';
import { ProductItemModel } from '../posts/types';

export async function getProductsByUrl(url: string): Promise<ProductItemModel> {
    const response = await axios.post('/products', {
        url,
        data_source: 'manual',
    });

    return toProductModel(response.data.product);
}
